// Implementation constants

export const DEFAULT_KEY = "|c70d_kp_maxandben_default_key_8da5|"

// String constants

const MAX_BEN_DOMAIN = "maxundben.at"
export const MAX_BEN_FQDN = `www.${MAX_BEN_DOMAIN}`
export const MAX_BEN_BASE_URL = `https://${MAX_BEN_DOMAIN}`
export const MAX_BEN_AGB_URL = `${MAX_BEN_BASE_URL}/agb`
export const MAX_BEN_HELP_URL = `${MAX_BEN_BASE_URL}/hilfe`
export const MAX_BEN_CONTACT_URL = `${MAX_BEN_BASE_URL}/kontakt`

export const KP_MAIN_ADMIN = "heimo.högl@gmail.com"
export const MAX_BEN_INFO_MAIL = `info@${MAX_BEN_DOMAIN}`
export const MAX_BEN_INFO_LANDLINE = "+43 316 68 28 00"

export const KP_ADDRESS = "Karl-Zeller-Weg 9, 8051 Graz"
export const MAX_BEN_TAGLINE = "MAX&BEN by Högl - Der Kassenprofi"

export const MAX_BEN_SENTRY_URL =
  "https://656e1a3ed2a97fd9039f4b6dfeed7bc5@o4509032222883840.ingest.de.sentry.io/4509117195026512"
